import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FoodDetailItem, HomeMenuCategoryWithFoods } from '../../interfaces/types';
import ConveyorBeltNew from './components/ConveyorbeltNew';

interface ListFoodSuggestedProps {
  activeCategory?: HomeMenuCategoryWithFoods;
  onFoodClick?: (food: FoodDetailItem, categoryId: string) => void;
}

const ListFoodSuggested: React.FC<ListFoodSuggestedProps> = ({ activeCategory, onFoodClick }) => {
  const { t } = useTranslation();

  const suggestedFoods = useMemo(() => {
    if (!activeCategory) return [];
    return activeCategory.foods
      .filter((food) => food.banner)
      .sort((a, b) => {
        const ao = typeof a.banner_order === 'number' ? a.banner_order : 9999;
        const bo = typeof b.banner_order === 'number' ? b.banner_order : 9999;
        return ao - bo;
      });
  }, [activeCategory]);

  if (!suggestedFoods || suggestedFoods.length === 0) {
    return null;
  }

  return (
    <div>
      <p className="text-gray-900 text-lg font-semibold leading-7 pl-4">{t('HOME_SUGGESTED')}</p>
      <ConveyorBeltNew suggestedFoods={suggestedFoods} activeCategoryId={activeCategory?.id || ''} onFoodClick={onFoodClick} />
    </div>
  );
};

export default ListFoodSuggested;
